import { useEffect, useState } from "react";

const navItems = [
  { label: "热门爆料", href: "#hot" },
  { label: "主题分类", href: "#categories" },
  { label: "最新爆料", href: "#feed" },
  { label: "社区口碑", href: "#community" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 items-center justify-between gap-4 px-4 md:px-6">
        <a href="#top" className="flex items-center gap-3 shrink-0 cursor-pointer" aria-label="99看料 首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
            99
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">99看料</span>
            <span className="mt-0.5 font-label text-[10px] md:text-xs tracking-[0.18em] text-foreground-500">看料 · 看你说</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="rounded-md px-3 py-2 font-label text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#submit"
            className="hidden sm:inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-quill-pen-line text-base" aria-hidden="true" />
            我要投稿
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-5 pt-3">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-3 font-label text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setMenuOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 font-label text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-quill-pen-line text-base" aria-hidden="true" />
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}